import { Injectable } from '@angular/core';
import {
  PDFUI,
  PDFUIOptions,
} from 'webcommon/lazy-load-commonjs/foxit';
import { FoxitPdfRendererBase } from './FoxitPdfRendererBase';

@Injectable()
export class FoxitRpnViewRenderer extends FoxitPdfRendererBase {
  override readonly pdfUI = this.createPDFUI();

  protected override getNewTemplate(): PDFUIOptions['template'] {
    return `
    <webpdf>
      <toolbar name="toolbar" class="fv__ui-toolbar-scrollable">
        <group-list name="home-toolbar-group-list" class="mb_10">
          <group name="comment-tab-group-stamp" retain-count="2">
            <single-page-button></single-page-button>
            <continuous-page-button></continuous-page-button>
          </group>
          <group name="home-tab-group-nav" retain-count="2">
            <goto-page-input></goto-page-input>
          </group>
          <group name="home-tab-group-zoom">
            <zoom-out-button></zoom-out-button>
            <editable-zoom-dropdown></editable-zoom-dropdown>
            <zoom-in-button></zoom-in-button>
          </group>
        </group-list>

        <!-- Add the other action buttons here. -->
      </toolbar>
      <div class="fv__ui-body">
        <sidebar name="sidebar">
          <search-sidebar-panel></search-sidebar-panel>
        </sidebar>
        <viewer></viewer>
      </div>
    </webpdf>
    `;
  }

  protected override createPDFUI(): PDFUI {
    const options = this.getOptions(
      this.foxitModule,
      this.foxitSetup,
      this.element,
    );

    const pdfUI = new this.foxitModule.PDFUI(options);
    pdfUI.addViewerEventListener('render-file-success', async (_pdfDoc) => {
      const viewModeMgr = await pdfUI.getViewModeManager();
      viewModeMgr.switchTo('continuous-view-mode');

      (await pdfUI.getPDFViewer()).zoomTo(1);
    });

    return pdfUI;
  }
}
